import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import SectionLabel from "../components/shared/SectionLabel";
import ProjectCard from "../components/shared/ProjectCard";
import MediumCard from "../components/shared/MediumCard";
import ExperienceTimeline from "../components/shared/ExperienceTimeline";
import { experiences } from "../data/experiences";
import { allProjects } from "../data/projects";

const ViewMore = ({ to, children }) => (
  <Link
    to={to}
    className="inline-flex items-center gap-1 text-sm text-accent hover:underline"
  >
    {children} <BiChevronRight className="w-4 h-4" />
  </Link>
);

const About = () => {
  const featuredProjects = allProjects.slice(0, 3);

  return (
    <div className="fade-up">
      <p className="font-mono text-sm text-accent">SOFTWARE ENGINEER</p>
      <h1 className="text-4xl lg:text-5xl font-bold mt-3 leading-tight">
        A result-driven software
        <br />
        engineer, focused on scale.
      </h1>
      <p className="text-muted mt-6 max-w-xl leading-relaxed">
        A result driven software engineer with a strong background in
        software development, specializing in building scalable and
        efficient systems. Passionate about solving complex problems using
        modern technologies and optimizing system performance. Proficient in
        Rust, TypeScript, Java, Next.js and Python with expertise in
        microservices, APIs, and cloud infrastructure.
      </p>

      <div className="mt-16">
        <SectionLabel
          action={<ViewMore to="/experience">Education & stack</ViewMore>}
        >
          experience
        </SectionLabel>
        <ExperienceTimeline experiences={experiences} />
      </div>

      <div className="mt-16">
        <SectionLabel action={<ViewMore to="/projects">View all</ViewMore>}>
          projects
        </SectionLabel>
        <div>
          {featuredProjects.map((project, i) => (
            <ProjectCard key={project.slug} project={project} index={i} />
          ))}
        </div>
      </div>

      <div className="mt-16">
        <SectionLabel action={<ViewMore to="/writing">View all</ViewMore>}>
          writing
        </SectionLabel>
        <MediumCard />
      </div>
    </div>
  );
};

export default About;
